import { useActiveOrg } from '~/hooks/org'
import { BackendTransaction, OrgMember } from '~/types'

export function useSubmittedBy(
  transaction: BackendTransaction,
): OrgMember | null {
  const { org } = useActiveOrg()

  const submittedByUserId =
    'submittedByUserId' in transaction
      ? transaction.submittedByUserId
      : undefined

  if (!submittedByUserId) return null

  return org?.members.find(({ id }) => id === submittedByUserId) ?? null
}
